import styled from "styled-components";

export const StyledMenu = styled.div`
  z-index: 9999;
`;
